import { Component, ElementRef, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-select',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './select.component.html',
  styleUrls: ['./select.component.scss']
})
export class SelectComponent {

  @Input() state:string = "";
  @Input() disabled?:string;

  constructor(el: ElementRef) { }

  ngOnInit(): void {
  }

  ngAfterViewInit(): void {
    if(this.disabled == "true") {
      let classDisabled = document.querySelectorAll(".ant-select-disabled")
      classDisabled.forEach((element:any) => {
        element.classList.add("fill")
      });
    }  
  }

}
